import cn from 'classnames';
import Account from './components/Account/Account.css';
import InfoField from './components/Account/InfoField/InfoField.css';
import DeleteAccountDialog from './components/Account/DeleteAccountDialog/DeleteAccountDialog.css';
import Sidebar from './components/Sidebar/Sidebar.css';
import MobileMenu from './components/Sidebar/MobileMenu/MobileMenu.css';
import PassenderSwitch from './components/Passenger/Field/Switch/Switch.css';
import PassengerSelect from './components/Passenger/Field/Select/Select.css';
import Checkout from './components/Checkout/Checkout.css';
import LoginPage from './components/LoginPage/LoginPage.css';
import Checkin from './components/Checkin/Checkin.css';
import OrderCard from './components/OrderCard/OrderCard.css';
const theme = {
    Account: {
        Account: {
            account__offers: Account.rmAccount__offers,
            checkbox: Account.rmAccount__checkbox,
            checked: Account.rmAccount__checked,
            account__footer: Account.rmAccount__footer,
            social__networks: Account.rmAccount__socialNetwork,
            phone__input: Account.phone__input
        },
        SocialButton: {
            add__icon: Account.rmAccount__socialAdd
        },
        InfoField: {
            inputBase: InfoField.inputBase,
            input__button: InfoField.input__button,
            indicator: InfoField.indicator,
            tooltip: InfoField.tooltip
        },
        DeleteAccountDialog: {
            Dialog: DeleteAccountDialog.Dialog,
            actions: DeleteAccountDialog.actions
        }
    },
    Sidebar: {
        Sidebar: {
            root: Sidebar.root,
            sidebar: Sidebar.sidebar,
            sidebar__item: Sidebar.sidebar__item,
            sidebar__item_selected: Sidebar.sidebar__item_selected,
            icon: Sidebar.icon,
            item__text: Sidebar.item__text,
            title: Sidebar.title
        },
        MobileMenu: {
            root: MobileMenu.root,
            wrapper: MobileMenu.wrapper,
            title: MobileMenu.title,
            content: MobileMenu.content,
            user__avatar: MobileMenu.user__avatar,
            user__info: MobileMenu.user__info,
            user__info__email: MobileMenu.user__info__email,
            menu__item: MobileMenu.menu__item,
            menu__item_selected: MobileMenu.menu__item_selected,
            icon: MobileMenu.icon
        }
    },
    Passenger: {
        Switch: {
            element: PassenderSwitch.element,
            element_active: PassenderSwitch.element_active,
            error: PassenderSwitch.error
        },
        Select: {
            helperText: PassengerSelect.helperText,
            option: PassengerSelect.option
        }
    },
    Input: {
        Input: {
            input: cn(Checkout.input, Account.rmInput, LoginPage.rmInput, Checkin.rmInput),
            input_filled: cn(LoginPage.rmInput_filled, Checkin.rmInput_filled),
            input_focused: cn(Checkout.input_focused, LoginPage.rmInput_focused, Checkin.rmInput_focused),
            input_error: cn(Checkout.input_error),
            real_input: cn(Checkout.real_input, Account.rmInput__real, LoginPage.rmInput__real, Checkin.rmInput__real),
            textField__root: cn(Checkout.textField__root, Account.rmInput__textField, LoginPage.rmInput__textField, Checkin.rmInput__textField),
            textField_focused: cn(Checkout.textField_focused),
            textField_standard: cn(Checkout.textField_standard),
            textField_filled: cn(Checkout.textField_filled),
            label_error: cn(Checkout.label_error),
            label_shrink: cn(Checkout.label_shrink, Account.rmInput__labelShrink, LoginPage.rmInput__labelShrink, Checkin.rmInput__labelShrink),
            hint_error: cn(Checkout.hint_error),
            hint: cn(Account.rmInput__hint),
            underline: cn(Checkout.underline)
        }
    },
    OrderCard: {
        OrderCard: {
            root: OrderCard.rmOrder__root,
            container: OrderCard.container,
            type_account: OrderCard.type_account
        },
        CommonItem: {
            root: cn(OrderCard.rmOrder__item, Account.rmOrder__item),
            icon: OrderCard.rmOrder__itemIcon
        },
        OrderPassengers: {
            control: OrderCard.rmOrder__control
        },
        OrderTickets: {
            link: OrderCard.rmOrder__control
        },
        OrderBooking: {
            download: OrderCard.rmOrder__downloadButton,
            root: OrderCard.rmOrder__bookingRoot,
            type_account: OrderCard.rmOrder__bookingAccount
        },
        OrderPreview: {
            inner: OrderCard.rmOrder__previewInner
        }
    }
};
export default theme;
